import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5108_v2_gift-page-experiment'

export const i18nInstance = registerI18nResources({
  namespace: GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
